// extracted by mini-css-extract-plugin
export default {"CreateTaskBody":"CreateTaskModal_CreateTaskBody__WESqe","titleInput":"CreateTaskModal_titleInput__jzN+w"};